import { FC, ReactNode } from "react";
import { Box, Typography, SxProps, Theme, alpha, useTheme } from "@mui/material";

interface IModernCard {
  title?: string;
  icon?: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
  headerAction?: ReactNode;
}

export const ModernCard: FC<IModernCard> = ({
  title,
  icon,
  children,
  sx,
  headerAction,
}) => {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  return (
    <Box
      sx={{
        background: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
        border: "1px solid",
        borderColor: alpha("#000", 0.06),
        overflow: "hidden",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
          transform: "translateY(-2px)",
        },
        ...sx,
      }}
    >
      {title && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1.5,
            px: { xs: 2, sm: 3 },
            py: { xs: 1.5, sm: 2 },
            background: `linear-gradient(135deg, ${alpha(primaryColor, 0.08)} 0%, ${alpha(primaryColor, 0.02)} 100%)`,
            borderBottom: "1px solid",
            borderColor: alpha(primaryColor, 0.1),
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            {icon && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 36,
                  height: 36,
                  borderRadius: "10px",
                  background: primaryColor,
                  color: "#fff",
                  "& svg": { fontSize: 20 },
                }}
              >
                {icon}
              </Box>
            )}
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: "text.primary",
                fontSize: { xs: "14px", sm: "16px" },
              }}
            >
              {title}
            </Typography>
          </Box>
          {headerAction}
        </Box>
      )}
      <Box sx={{ p: { xs: 2, sm: 3 } }}>{children}</Box>
    </Box>
  );
};
